export default __webpack_public_path__ + "static/media/institute_sign_up_img.0f35c6c3.png";